import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { ButtonBack } from '../../../common/html/button/ButtonBack'
import { InputRename } from '../../../common/html/input/InputRename'
import { TextTwoLine } from '../../../common/html/text'
import { ROUTE_LIBRARY, TYPE_DELETE } from '../../../constant'
import { DeletePortfolio } from '../../portfoliosOverview/components/DeletePortfolio'
import { CustomTdAlert } from '../../portfoliosOverview/schemaTableSavedPortfolio/CustomTdAlert'
import { selectTypeAlert } from '../../portfoliosOverview/store/slice/slice'
import { changeFragment } from '../../portfoliosOverview/store/slice/sliceComponent'
import { delDeletePortfolio } from '../../portfoliosOverview/store/thunk'
import style from '../index.module.scss'
import {
  changeTypeAlertDetail,
  selectDataHeaderPortfolioDetail,
  selectTypeAlertDetail,
} from '../store/slice'

export const Header = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchId] = useSearchParams()
  const id = searchId.get('id')

  const data = useSelector(selectDataHeaderPortfolioDetail)
  const typeAlert = useSelector(selectTypeAlert)
  const dataSelect = useSelector(selectTypeAlertDetail)
  const locale = useSelector((state) => state.i18n.locale)

  const [isShowRename, setShowRename] = useState(false)
  const [name, setName] = useState(data?.portfolioName)
  const [isShowDelete, setIsShowDelete] = useState(false)

  const handleConfirmDelete = () => {
    dispatch(
      delDeletePortfolio({
        portfolioIds: [id],
        deleteType: TYPE_DELETE.IN,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(changeFragment())
        navigate(`${ROUTE_LIBRARY.SAVED_PORTFOLIOS}`)
      })
      .catch(() => {})
    setIsShowDelete(false)
  }

  useEffect(() => {
    dispatch(
      changeTypeAlertDetail(
        typeAlert.find((item) => item.value === data?.alertProfileId),
      ),
    )
  }, [typeAlert, data])

  return (
    <>
      <div>
        <Element className={style.header} style={{ borderColor: '#e5e5e8' }}>
          <ButtonBack
            text="library.main.BACK_PORTFOLIO"
            linkTo={ROUTE_LIBRARY.SAVED_PORTFOLIOS}
          />
          <Element
            className={['dFlex alignItemsCenter', style.headerContainer].join(
              ' ',
            )}
            style={{
              backgroundColor: '#f9f9f9',
            }}
          >
            <Element
              className={[
                'dFlex alignItemsCenter gap1 w100',
                style.mainTitle,
              ].join(' ')}
            >
              {!isShowRename ? (
                <>
                  <Element className={style.title}>
                    <Element
                      style={{ fontSize: 20, color: '#3a414b' }}
                      className={style.textTitle}
                    >
                      <TextTwoLine text={name || data?.portfolioName} />
                    </Element>
                  </Element>
                  <Icon
                    className="icon-edit-outline"
                    style={{ fontSize: 18, color: '#9C9C9C' }}
                    onClick={() => setShowRename(true)}
                  />
                  <Icon
                    className="icon-trash-fill"
                    style={{ fontSize: 18, color: '#9C9C9C' }}
                    onClick={() => setIsShowDelete(true)}
                  />
                </>
              ) : (
                <InputRename
                  defaultValue={data?.portfolioName}
                  bgColorIcon="#f9f9f9"
                  containerStyle={{
                    width: '100%',
                    margin: '12px 0',
                  }}
                  style={{
                    height: 24,
                    width: '100%',
                    backgroundColor: '#f9f9f9',
                    fontSize: 20,
                    lineHeight: 24,
                  }}
                  setShowInput={setShowRename}
                  isOnTable={false}
                  rowId={id}
                  setName={setName}
                />
              )}
            </Element>

            <Element
              className={[
                'dFlex alignItemsCenter justifyContentEnd ',
                style.listInf,
              ].join(' ')}
            >
              <Element className={style.item}>
                <Element
                  elementName="span"
                  style={{
                    whiteSpace: 'nowrap',
                  }}
                >
                  <Translate value="library.detailsPortfolios.NUMBER_OF_COMPANIES" />
                </Element>
                <Element elementName="p">{data?.numberOfCompany || 0}</Element>
              </Element>
              <Element className={style.item}>
                <Element elementName="span" style={{ whiteSpace: 'nowrap' }}>
                  <Translate value="library.detailsPortfolios.ALERT_PROFILE" />
                </Element>
                <Element>
                  <CustomTdAlert
                    data={dataSelect}
                    rowId={data?.portfolioId}
                    colId={'alertProfileId'}
                    isDetail={true}
                  />
                </Element>
              </Element>
              <Element className={style.item}>
                <Element elementName="span" style={{ whiteSpace: 'nowrap' }}>
                  <Translate value="library.detailsPortfolios.DATE_CREATED" />
                </Element>
                <Element elementName="p" style={{ whiteSpace: 'nowrap' }}>
                  {formatDateTime(data?.createDate, FORMAT.DATE, locale)}
                </Element>
              </Element>
              <Element className={style.item}>
                <Element elementName="span" style={{ whiteSpace: 'nowrap' }}>
                  <Translate value="library.detailsPortfolios.DATE_MODIFIED" />
                </Element>
                <Element elementName="p" style={{ whiteSpace: 'nowrap' }}>
                  {formatDateTime(data?.updateDate, FORMAT.DATE, locale)}
                </Element>
              </Element>
            </Element>
          </Element>
          {isShowDelete && (
            <DeletePortfolio
              isShow={isShowDelete}
              setShow={setIsShowDelete}
              handleDelete={handleConfirmDelete}
              renderContent={() => (
                <>
                  <Element
                    elementName="p"
                    style={{ overflowWrap: 'break-word' }}
                  >
                    <Translate
                      value="library.savePortfolio.TEXT_DELETE_PORTFOLIO"
                      name={data?.portfolioName}
                      dangerousHTML
                    />
                  </Element>
                </>
              )}
            />
          )}
        </Element>
      </div>
    </>
  )
}
